"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PuzzleSolution = exports.BlockHeader = exports.CoinState = exports.Coin = void 0;
var coin_1 = require("../../util/serializer/types/coin");
Object.defineProperty(exports, "Coin", { enumerable: true, get: function () { return coin_1.Coin; } });
class CoinState {
}
exports.CoinState = CoinState;
class BlockHeader {
}
exports.BlockHeader = BlockHeader;
class PuzzleSolution {
}
exports.PuzzleSolution = PuzzleSolution;
//# sourceMappingURL=provider_types.js.map